module.exports = __webpack_public_path__ + "media/images/icons/v2/check-f83f8025d8513645cda484c02ab4ccd8.svg";